<template>
  <div class="wrap">
    <div class="mask" @touchmove.prevent></div>
    <div class="container" >
      <!-- 领取成功 -->
      <div v-if="step == 1" class="l-sc">
        <p>领取成功</p>
        <p>快去游戏内查看吧</p>
        <button @click="close"></button>
      </div>
      <div v-if="step == 2" class="l-sc">
        <p>登录成功</p>
        <p>快去参加活动吧</p>
        <button @click="close"></button>
      </div>
      <!-- 绑定角色 -->
      <div v-if="step == 3" class="l-ac">
        <p class="title">绑定角色</p>
        <div class="sc" @click="selectServer">
          <p>区服：</p>
          <div>
            <p>{{ cServer.text || '请选择区服' }}</p>
            <img :src="`${cdnUrl}/tg2/tk/8.png`" alt="">
          </div>
        </div>
        <div class="sc" @click="selectRole">
          <p>角色：</p>
          <div>
            <p>{{ cRole.text || '请选择角色' }}</p>
            <img :src="`${cdnUrl}/tg2/tk/8.png`" alt="">
          </div>
        </div>
        <button @click="handleBind"></button>
      </div>
      <!-- 奖品 -->
      <div v-if="step == 4" class="g-l">
        <p class="title">我的奖品</p>
        <ul>
          <li>
            <p>活动名称</p>
            <p>奖品名称</p>
            <p>领取角色</p>
            <p>领奖时间</p>
          </li>
          <ul>
            <li v-for="(item, index) in giftList" :key="index">
              <p>{{ item.activity_name }}</p>
              <p>{{ item.shaoge_gift_name }}</p>
              <p>{{ item.role_name }}</p>
              <p>{{ moment(item.created_at).format('YYYY-MM-DD') }}</p>
            </li>
          </ul>
        </ul>
      </div>
      <!-- 活动规则 -->
      <div v-if="step == 5" class="rule">
        <p class="title">活动规则</p>
        <div>
          <p>1、活动持续时间：活动上线，至2025年1月31日23：59：59；</p>
          <p>2、创角时间范围：2024年8月19日00：00：00——2024年12月31日23：59：59</p>
          <p>3、活动持续期间，在本页面绑定游戏内角色，符合创角时间范围的玩家，即可参与本次7天以及15天冲级活动；</p>
          <p>4、绑定角色在创角7天/15天内（自然日计算），达到对应等级后，即可领取对应档位礼包，道具奖励将会直接发放至游戏内绑定角色的邮箱；</p>
          <p>5、代金券发放后，登录绑定角色对应账号，在游戏内支付时可以直接使用；</p>
          <p>6、部分渠道服角色若无法参与活动的情况下，可于活动页面下载游戏，并前往新服创角即可参与；</p>
          <p>7、活动过程中，凡以不正当手段（如作弊领取、违规注册、恶意刷奖、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，主办方有权终止其参与活动，并取消其获奖资格（如奖品已发放则有权追回）；</p>
          <p>8、如遇不可抗力（包括但不限于重大灾害事件、社会事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行），活动方有权取消、修改或暂停本活动。</p>
          <p>9、请获奖用户在收到奖品后对奖品进行验证，所有奖品如有问题请在15天内进行反馈，过期将不接受处理；</p>
          <p>10、如有疑问请于游戏内，点击悬浮窗-【客服】，联系客服咨询；</p>
        </div>
        <button @click="close"></button>
      </div>
      <!-- 账号密码登录 -->
      <div v-if="step == 6" class="l-al">
        <div class="tabs">
          <span :class="[lp == 1 ? 'active' : '']" @click="lp = 1">账号登录</span>
          <span :class="[lp == 2 ? 'active' : '']" @click="lp = 2">手机号登录</span>
        </div>
        <div class="input-wrap" v-if="lp == 1">
          <input type="text" v-model="username" placeholder="请输入用户名">
          <input type="password" v-model="password" placeholder="请输入密码">
        </div>
        <div class="input-wrap" v-if="lp == 2">
          <input type="number" inputmode="numeric" v-model="phone" placeholder="请输入11位手机号">
          <div class="code">
            <input type="password" v-model="code" placeholder="请输入验证码">
            <span @click="getCode" v-if="!count">获取</span>
            <span v-else>{{ count }}</span>
          </div>
        </div>
        <button @click="handleLogin"></button>
        <p class="hint">没有账号？<span @click="$emit('download')">下载游戏注册账号</span></p>
      </div>
      <!-- 无账号 -->
      <div v-if="step == 7" class="l-nc">
        <p>您还没有账号</p>
        <p>快去下载游戏注册账号吧~</p>
        <button @click="$emit('download')"></button>
      </div>
      <img :src="`${cdnUrl}/tg2/5.png`" alt="" class="close" @click="close">
    </div>
    <Popup v-model="showPicker" round position="bottom">
      <Picker
        :title="pickerTitle"
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </Popup>
  </div>
</template>
<script>
import { CDN_URL_1 } from "@/config";
import { Toast, Picker, Popup } from 'vant';
import { shaogeActRoleBind, smsCodeApi, accountLoginApi, telLoginApi } from '@/apis/tg'
import moment from 'moment';
import CryptoJS from 'crypto-js';

export default {
  data() {
    return {
      moment,
      cdnUrl: CDN_URL_1,
      step: 3, // 1.礼包领取成功  3.绑定角色 4.我的奖品 5.活动规则  6 7
      giftList: [],
      pickerTitle: '',
      columns: [],
      showPicker: false,
      roleList: [],
      cServer: {},
      cRole: {},
      userInfo: {},
      username: '',
      password: '',
      lp: 1, // 登录类型 1.账号密码 2.手机号
      phone: '',
      code: '',
      loginFlag: false,
      timer: null,
      count: 0,
    };
  },
  props: ['server'],
  mounted() {
  },
  methods: {
    setStep(step) {
      this.step = step;
      if (this.step == 3) {
        this.cServer = {};
        this.cRole = {}
        this.roleList = [];
      }
    },
    close() {
      this.$emit('close')
    },
    setRecordList(list) {
      this.giftList = list;
    },
    async getCode() {
      let reg = new RegExp(/^(\+?0?86-?)?1[3-9]\d{9}$/);
      if (!reg.test(this.phone)) {
        Toast('请输入正确的手机号')
        return;
      }
      this.setTimer();
      try {
        const time = Math.ceil((new Date().getTime())/1000)
        const sign = CryptoJS.MD5(CryptoJS.MD5("unknown"+ time + this.phone) + "unknown"+ time + this.phone).toString();
        await smsCodeApi({ 
          device_id: 'unknown',
          tel_num: this.phone,
          time,
          sign
        });
        Toast('发送成功')
      } catch (error) {
        this.clearTimer();
        console.log(error)
        if (error.ret) {
          if (error.ret == 201) {
            this.setStep(7)
          } else {
            Toast(error.msg)
          }
        } else {
          Toast('系统异常')
        }
      }
    },
    setTimer() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    clearTimer() {
      this.count = '';
      clearInterval(this.timer);
      this.timer = null;
    },
    handleLogin() {
      this.lp == 1 ? this.accountLogin() : this.cellLogin()
    },
    async accountLogin() {
      if (!this.username || !this.password) {
        Toast('用户名或密码不能为空');
        return;
      }
      if (this.loginFlag) return;
      this.loginFlag = true;
      try {
        const r = await accountLoginApi({
          user_name: this.username,
          password: CryptoJS.MD5(
            this.password + CryptoJS.MD5(this.password)
          ).toString(),
        })
        this.loginFlag = false;
        localStorage.setItem('tg_user_info', JSON.stringify(r.content));
        this.$emit('loginSuccess', r.content);
      } catch (error) {
        this.loginFlag = false;
      }    
    },
    async cellLogin() {
      if (!this.phone || !this.code) {
        Toast('手机号或验证码不能为空');
        return;
      }
      if (this.loginFlag) return;
      this.loginFlag = true;
      try {
        const r = await telLoginApi({
          tel: this.phone,
          code: this.code,
        })
        this.loginFlag = false;
        localStorage.setItem('tg_user_info', JSON.stringify(r.content));
        this.$emit('loginSuccess', r.content);
      } catch (error) {
        this.loginFlag = false;
      }
    },
    async handleBind() {
      if (!this.cServer.id || !this.cRole.id) {
        Toast('请选择区服和角色');
        return;
      }
      try {
        const r = await shaogeActRoleBind({
          user_id: this.userInfo.user_id,
          server_id: this.cServer.id,
          role_id: this.cRole.id,
          activity_token: this.userInfo.activity_token
        })
        this.$emit('bind', r.content);     
      } catch (error) {
        if (error.ret) {
          if (error.ret == 2003) {
            this.$emit('bind', {
              user_role: {
                server_id:  this.cServer.id,
                server_name: this.cServer.text,
                role_id: this.cRole.id,
                role_name: this.cRole.text,
              }
            }); 
          } else {
            Toast(error.msg);
          }
        }
      }
    },
    onConfirm(item) {
      if (!item) {
        this.showPicker = false;
        return;
      }
      if (this.pickerTitle == '请选择区服') {
        this.cServer = item;
        this.roleList = item.role || [];
        this.cRole = {};
      } else {
        this.cRole = item;
      }
      this.showPicker = false;
    },
    selectServer() {
      this.pickerTitle = '请选择区服';
      this.columns = this.server;
      this.showPicker = true;
    }, 
    selectRole() {
      this.pickerTitle = '请选择角色';
      this.columns = this.roleList;
      this.showPicker = true;
    }
  },
  components: {
    Picker,
    Popup
  },
};
</script>
<style scoped lang="scss">
.wrap {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba($color: #000000, $alpha: 0.6);
    z-index: 1000;
  }
  .container {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 360px;
    height: 321px;
    text-align: center;
    z-index: 1001;
    > div {
      width: 340px;
      height: 260px;
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/2/1.png') no-repeat;
      background-size: 100% 100%;
      text-align: center;
      padding-top: 30px;
      margin: auto;
    }
    .l-sc {
      padding-top: 70px;
      line-height: 26px;
      color: #181612;
      font-size: 16px;
      .title {
        font-size: 18px;
      }
      > button {
        margin-top: 20px;
        width: 108px;
        height: 44px;
        background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/2/5.png') no-repeat;
        background-size: 100% 100%;
        color: #363D38;
        font-size: 15px;
        border: none;
        outline: none;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .l-ac {
      padding-top: 40px;
      .title {
        font-size: 16px;
        margin-bottom: 10px;
      }
      .sc {
        text-align: left;
        padding-left: 90px;
        > div {
          width: 170px;
          display: flex;
          margin-top: 4px;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #D1B670;
          padding-bottom: 5px;
          margin-bottom: 10px;
          color: #7E7E7E;
          font-size: 12px;
          > img {
            width: 20px;
            height: 10px;
          }
        }
      }
      > button {
        margin-top: 15px;
        margin-bottom: 8px;
        width: 108px;
        height: 40px;
        background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/2/4.png') no-repeat;
        background-size: 100% 100%;
        color: #363D38;
        font-size: 15px;
        border: none;
        outline: none;
        &:active {
          opacity: 0.8;
        }
      }
      .hint {
        font-size: 12px;
        color: #787878;
        > span {
          color: #ecba3a;
        }
      }
    }
    .g-l {
      padding-top: 40px;
      text-align: center;
      .title {
        font-size: 16px;
        margin-bottom: 10px;
      }
      > ul {
        width: 280px;
        display: inline-block;
        font-size: 11px;
        overflow-y: auto;
        li {
          width: 100%;
          display: flex;
          justify-content: center;
          .copyBtn {
            > span {
              color: #0368FF;
              text-decoration: underline;
            }
          }
          >p:nth-child(1) {
            width: 20%;
          }
          >p:nth-child(2) {
            width: 35%;
          }
          >p:nth-child(3) {
            width: 20%;
          }
          >p:nth-child(4) {
            width: 25%;
          }
          > p {
            line-height: 16px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
        > li:nth-child(1) {
          border-bottom: 1px solid #D1B670;
          padding-bottom: 3px;
          margin-bottom: 5px;
        }
        > ul {
          height: 145px;
          overflow-y: auto;
        }
      }
    }
    .rule {
      padding-top: 40px;
      .title {
        font-size: 16px;
        margin-bottom: 10px;
      }
      > div {
        width: 200px;
        height: 120px;
        display: inline-block;
        font-size: 11px;
        overflow-y: auto;
        text-align: left;
        line-height: 16px;
      }
      > button {
        display: block;
        margin: auto;
        margin-top: 5px;
        width: 108px;
        height: 44px;
        background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/2/5.png') no-repeat;
        background-size: 100% 100%;
        color: #363D38;
        font-size: 15px;
        border: none;
        outline: none;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .l-al {
      .tabs {
        color: #181612;
        font-size: 16px;
        padding: 24px 0 20px;
        display: flex;
        justify-content: center;
        > span {
          margin: 0 10px;
          position: relative;
          &.active {
            &::before {
              position: absolute;
              content: ' ';
              bottom: -14px;
              left: 0;
              right: 0;
              margin: auto;
              width: 50px;
              height: 10px;
              background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2/25.png') no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
      .input-wrap {
        width: 182.99px;
        margin: auto;
        > input {
          width: 182.99px;
          height: 35.07px;
          background: #f7f7f7;
          border-radius: 17.36px;
          padding: 0 15px;
          margin-bottom: 6px;
        }
        .code {
          display: inline-block;
          width: 182.99px;
          height: 35.07px;
          background: #f7f7f7;
          border-radius: 17.36px;
          margin-bottom: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          > input {
            width: 132.99px;
            height: 35.07px;
            background: #f7f7f7;
            border-radius: 17.36px;
            padding: 0 3px;
            margin-right: 5px;
          }
          > span {
            color: #FF9C00;
            font-size: 11px;
          }
        }
      }
      > button {
        margin-bottom: 8px;
        width: 108px;
        height: 44px;
        background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/2/2.png') no-repeat;
        background-size: 100% 100%;
        color: #363D38;
        font-size: 15px;
        border: none;
        outline: none;
        &:active {
          opacity: 0.8;
        }
      }
      .hint {
        font-size: 12px;
        color: #787878;
        > span {
          color: #ecba3a;
        }
      }
    }
    .l-nc {
      padding-top: 80px;
      line-height: 26px;
      color: #181612;
      font-size: 14px;
      .title {
        font-size: 16px;
      }
      > button {
        margin-top: 20px;
        width: 108px;
        height: 44px;
        background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/2/6.png') no-repeat;
        background-size: 100% 100%;
        color: #363D38;
        font-size: 15px;
        border: none;
        outline: none;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .close {
      width: 35px;
      height: 35px;
      display: inline-block;
      margin: auto;
    }
  }
}
</style>
